import React, { useEffect, useState } from 'react'
import A4Page from '../A4Page'
import TopDetail from '../TopDetail'
import Page1 from './Page1'
import PageKall from './PageKall'
import PageKallLittle from './PageKallLittle'
import { ReactComponent as Zaraön } from '../../../../../assets/Varlık2.svg'
import useOrderStore from 'store/client/orderStore'
import { IoTriangleOutline } from 'react-icons/io5'
import { IoTriangle } from 'react-icons/io5'
import { ReactComponent as ZaraBom } from '../../../../../assets/DD.svg'
import { ReactComponent as ZaraBomRed } from '../../../../../assets/DDRED.svg'
import { ReactComponent as AUDDOLAR } from '../../../../../assets/DDRED.svg'
import { ReactComponent as ZaraAcc } from '../../../../../assets/zaraaccess01.svg'
import { ReactComponent as ZaraAccLinge } from '../../../../../assets/linnngee.svg'
import { ReactComponent as ZaraAccEmty } from '../../../../../assets/accesemty.svg'
import { ReactComponent as ZaraAccLin } from '../../../../../assets/accesslin.svg'
import { ReactComponent as CardFront } from '../../../../../assets/waist/waistback.svg';
import { ReactComponent as CardFront3292 } from '../../../../../assets/waist/3292backwaist.svg';
import { ReactComponent as WTZCAL0 } from '../../../../../assets/waist/WTZCALL002.svg';

import { ReactComponent as ZaraFscrrkall } from '../../../../../assets/waist/fscrrkall.svg'
import { ReactComponent as ZaraFsctmkall } from '../../../../../assets/waist/fsctmkall.svg'
import { ReactComponent as ZaraFsctmpaperkall } from '../../../../../assets/waist/fsctmpaperkall.svg'

import { ReactComponent as CardDeneme } from '../../../../../assets/waist/waistemty.svg';
import { ReactComponent as CardTry1 } from '../../../../../assets/cleanedtry.svg';
import { Line } from '@react-pdf/renderer'
import requests from 'service/api'


const loadSVG = async (code,referenceWidth,referenceHeight,isyatay) => {
  console.log("referenceWidth",referenceWidth);
  console.log("referenceHeight",referenceHeight);
  console.log("code",code);
  try {
    console.log(`[loadSVG] Gelen kod: ${code}`);

    if(code==="BACK"){
      return null;
    }
    
    const response = await requests.order.getBrandSvg(code, { type: 'brand' });
    //console.log("response",response);
    // SVG string'ini React component'ine çevir
    let svgString = response.data;
    
    // SVG string'ine viewport ekle
    const parser = new DOMParser();
    const doc = parser.parseFromString(svgString, 'image/svg+xml');
    const svgElement = doc.querySelector('svg');
    
    if (svgElement) {
      // Mevcut viewBox'ı koru
      
      // Width ve height ekle
      svgElement.setAttribute('width', `${referenceWidth}mm`);

      // Güncellenmiş SVG string'ini al
      svgString = new XMLSerializer().serializeToString(doc);
    }

    return () => (
        <div style={{ 
          width: `${referenceWidth}mm`, 
          height: `${referenceHeight}mm`, 
          position: "relative",
          // Yatay düzenlemede SVG'yi büyütmek için transform kullan
          marginTop: isyatay === "yatay" ? "2px" : "0px",
          transform: isyatay === "yatay" ? "scale(1.27)" : "scale(1)",
          transformOrigin: "center"
        }} dangerouslySetInnerHTML={{ __html: svgString }} />
    );
  } catch (error) {
    console.error(`[loadSVG] SVG yüklenemedi. Kod: ${code}, Hata:`, error);
    alert("hata verdi");

    return null;
  }
};



const renderDiv = (referenceCode, referenceWidth) => {
  let style = {
    width: "50.2mm",
    height: "102mm",
    position: "absolute",
    top: 0.4,
    left: -0.4,
    zIndex: 36,
    opacity: "1",
  };

  if (referenceCode.includes("CALL") && referenceWidth === 50) {
    style.width = "50.2mm";
    style.height = "102.2mm";
  } else if (referenceCode.includes("KALL") && referenceWidth === 50) {
    style.width = "50.2mm";
    style.height = "102.2mm";
  } else if (referenceCode.includes("KALL") && referenceWidth === 32) {
    style.width = "32.2mm";
    style.height = "92.1mm";
    style.top=0;  
  }

  return (
    <div style={style}>
      <div style={{ width: style.width, height: style.height, border: style.border }}></div>
    </div>
  );
};
/*   <Page1
                              key={groupObj.startIndex + index}
                              selectColor={selectColor}
                              barcodeValue={`0${data?.articleNo?.split('/')[0]}${data?.articleNo?.split('/')[1]}${data?.beltLabel[selectColor]?.colorCode}${sizeData.sCode ? sizeData.sCode : ''}`}
                              data={data}
                              referance={data?.reference}
                              SouthAmerica={SouthAmerica}
                              sizeData={sizeData}
                              indo={data?.beltLabel[0]?.sizes}
                              szrgrp={data?.sizeGroup}
                              inx={groupObj.startIndex + index}
                            /> */
const CardComponent = ({ referenceCode, referenceWidth, referenceHeight, data, selectedFscType,isyatay }) => {
  const [SvgComponent, setSvgComponent] = useState(null);
  useEffect(() => {
    if (referenceCode) {
      //alert("refcode",referenceCode);
      if(referenceCode==="BACK"){
        return;
      }
      loadSVG(referenceCode,referenceWidth,referenceHeight,isyatay)
        .then((component) => {
          if(component !==null){
          setSvgComponent(() => component);
          }
        })
        .catch((error) => {
          console.error("[CardComponent] SVG yüklenirken hata:", error);
        });
    }
  }, [referenceCode]);

  if (!SvgComponent) {
    return <span>Loading...</span>;
  }
  if(SvgComponent === "function"){
    alert("svgcomponent function");
  }
  return (
    <div style={{ 
      width: `${referenceWidth}mm`, 
      height: "auto", 
      position: "relative",
      // Yatay düzenlemede SVG'yi büyütmek için transform kullan
      transform: isyatay === "yatay" ? "scale(1.2)" : "scale(1)",
      transformOrigin: "top left"
    }}>
      {typeof SvgComponent === "function" ? (
        <SvgComponent width={`${referenceWidth}mm`} height="auto" />
      ) : (
        <img src={SvgComponent} alt="SVG Image" style={{ width: `${referenceWidth}mm`, height: "auto" }} />
      )}
    </div>
  );
};

const BrandMain = ({ data, selectColor, tab }, ref) => {
  const department = data.department
  const [brand, category, subCategory] = department.split(' / ')
  const [SouthAmerica, setSouthAmerica] = useState(false)
  const [loading, setLoading] = useState(true);
  const [CardBackBack, setCardBackBack] = useState(null);
  const [shouldRender, setShouldRender] = useState(false);
  const [RefCode, setRefCode] = useState('');
  const [RefWidth, setRefWidth] = useState(0);
  const [RefHeight, setRefHeight] = useState(0);

  const [hasRefreshed, setHasRefreshed] = useState(false);
  const [fscToLogo, setfscToLogo] = useState("var");
  const selectedFscType = data.company?.fsctype;
  const selectedFscTopLogo = data.company?.fsctoplogo;


  const { referance } = useOrderStore()

  const [harmacn, setHarmacn] = useState(false) // harmacn state'i

  useEffect(() => {
    if (data.company?.fsctoplogo) {
      setfscToLogo(data.company?.fsctoplogo);
 
    }
  }, [data.company?.fsctoplogo]);


  useEffect(() => {

    if (referance?.code) {
      if(referance?.code==="BACK"){
        return;
      }
      setRefCode(referance.code);
      setRefWidth(referance.width);
      setRefHeight(referance.height)
      loadSVG(referance.code,referance.width,referance.height,referance.line3)
        .then((component) => {
          //console.log("[useEffect - referance] Yüklenen SVG Component:", component);
          if(component !==null){
          setCardBackBack(() => component);
          }
        })
        .catch((error) => {
          console.error("[useEffect - referance] SVG yüklenirken hata:", error);
        });
    }
  }, [referance]);
  

  useEffect(() => {
    if (referance) {
      setShouldRender(true);
    }
    
  }, [referance]);


  const isBlack = referance?.backgroundColor === 'B'


  

  // item.amount > 0 koşulunu sağlayan öğeleri filtrele ve her 8 öğede bir grupla
  const filteredAndGroupedSizes = data.brandLabel[selectColor].sizes
    .filter((item) => item.amount > 0)
    .reduce((acc, item, index) => {
      const groupIndex = Math.floor(index / referance?.linecount) // Her 3 öğe için bir grup indeksi
      if (!acc[groupIndex]) {
        acc[groupIndex] = { items: [], startIndex: index - (index % referance?.linecount) } // Yeni bir grup oluştur
      }
      acc[groupIndex].items.push(item)
      return acc
    }, [])

  return (
    
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }} ref={ref}>
    
    {referance?.line1 ? (
  filteredAndGroupedSizes.map((groupObj, groupIndex) => (
    <A4Page key={groupIndex} type={referance?.line3}>
      <div className="space-y-5" style={{ position: 'relative' }}>
        <div
          style={{
            position: 'absolute',
            top: '135px',
            left: `50px`,
          }}
        >

        </div>
        <TopDetail 
          values={data} 
          selectColor={selectColor} 
          tab={tab} 
          selectedFscTopLogo={data.company?.fsctoplogo || "defaultLogo"} 
        />

          {groupObj.items.map((sizeData, index) => (
            <div key={index}>
              <div
           
              >


  {/* Absolute Center Element */}
  <div 
  style={{ 
    zIndex: 2,
    backgroundColor: "transparent",
    width: `${RefWidth}mm`,
    minHeight: `${RefHeight}mm`,
    textAlign: "center",
    marginBottom: 10,
    position:"absolute",
    top: referance?.line3 === "dikey"
      ? `${referance?.topstart + index * referance?.topinc}px`
      : `${referance?.topstart}px`,                       // fixed if "dikey"

    left: referance?.line3 === "yatay"
      ? `${referance?.leftstart + index * referance?.leftinc}px`       // <--- your custom formula here
      : `${referance?.leftstart}px`,                       // fixed if "dikey"
  }}
  
>
    <Page1
key={groupObj.startIndex + index} // Global index kullanımı
      selectColor={selectColor}
      barcodeValue={`0${data?.articleNo?.split('/')[0]}${data?.articleNo?.split('/')[1]}${data?.priceLabel[selectColor]?.colorCode}${sizeData.sCode ? sizeData.sCode : ''}`}
      data={data}
      harmacn={harmacn}
      referance={referance}
      SouthAmerica={SouthAmerica}
      sizeData={sizeData}
      indo={data?.brandLabel[0]?.sizes}
      szrgrp={data?.sizeGroup}
      inx={groupObj.startIndex + index} // Global index kullanımı
      CardBackBack={CardBackBack}
     
    />
  </div>
 
  {renderDiv(RefCode, RefWidth)}

              </div>
            </div>
          ))}

          {referance?.line2 === "hasback" && (
            <div style={{ position:"absolute",   top: referance?.line3 === "dikey"
      ? `${referance?.topstart + referance?.linecount * referance?.topinc}px`
      : `${referance?.topstart}px`,                       // fixed if "dikey"

    left: referance?.line3 === "yatay"
      ? `${referance?.leftstart - referance?.linecount * referance?.left}px`       // <--- your custom formula here
      : `${referance?.leftstart}px`,          }}>
    <CardComponent
      referenceCode={RefCode + "BACK"} 
      referenceWidth={RefWidth}
      referenceHeight={RefHeight}
      data={data}
      selectedFscType={selectedFscType}
      isyatay={referance?.line3}
    />
    </div>
  )}
        </div>
    </A4Page>
  ))
) : (
  <A4Page key={1} type="dikey">
      <div className="space-y-5" style={{ position: 'relative' }}>
        <div
          style={{
            position: 'absolute',
            top: '135px',
            left: `50px`,
          }}
        >
        <div style={{display:"flex",justifyContent:"center",alignItems:"center",width:"30vw",paddingTop:40}}>
          <CardComponent 
            referenceCode={RefCode} 
            referenceWidth={RefWidth} 
            data={data} 
            selectedFscType={selectedFscType} 
            isyatay={referance?.line3}
          />
          </div>
        </div>
        <TopDetail 
          values={data} 
          selectColor={selectColor} 
          tab={tab} 
          selectedFscTopLogo={data.company?.fsctoplogo || "defaultLogo"} 
        />
    
      </div>
    </A4Page>
)}

    </div>
  )
}

export default React.forwardRef(BrandMain)
